export default function getPath()
{
  const url = document.location.toString();
  const arrUrl = url.split("//");

  const start = arrUrl[1].indexOf("/");
  return arrUrl[1].substring(start);
}
